import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { capture } from '~/lib/posthog';

export function usePostHogPageview() {
  const location = useLocation();
  const prevPath = useRef<string | null>(null);

  useEffect(() => {
    const currentUrl = window.location.href;
    const searchParams = new URLSearchParams(window.location.search);

    capture('$pageview', {
      $current_url: currentUrl,
      $pathname: location.pathname,
      $referrer: document.referrer || undefined,
      $referring_domain: document.referrer ? new URL(document.referrer).hostname : undefined,
      $previous_url: prevPath.current ? `${window.location.origin}${prevPath.current}` : undefined,
      utm_source: searchParams.get('utm_source') || undefined,
      utm_medium: searchParams.get('utm_medium') || undefined,
      utm_campaign: searchParams.get('utm_campaign') || undefined,
      utm_term: searchParams.get('utm_term') || undefined,
      utm_content: searchParams.get('utm_content') || undefined,
    });

    prevPath.current = location.pathname;
  }, [location.pathname]);
}
